export default __webpack_public_path__ + "static/earo-bg-6f3aac0ffff94d79555e37c692004849.png";